import { useTranslation } from 'react-i18next';
import { FormItem } from '../../../../components/FormItem';
import { FormItemName } from '../../../../lib/models/Form';
import { FormInput } from '../../../../components/FormInput';

import styles from './index.module.scss';

import { ReactComponent as LinkIcon } from './../../../../assets/icons/link-icon-gray.svg';

const helpAndContact = 'unique.formItems.helpAndContact';

const url = 'unique.formItems.url';

export const ClientHelpAndContactUrlFormItem = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.HELP_AND_CONTACT}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },
        {
          type: 'url',
          message: t(`${url}.errors.invalid`),
        },
        { max: 200 },
      ]}
    >
      <FormInput className={styles.inputUrl} icon={<LinkIcon />} label={t(`${helpAndContact}.label`)} />
    </FormItem>
  );
};
